import { InstallApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

const service = InstallApi({}, '/api', axiosInstance);

export const installApi = { ...service };
